import { render, staticRenderFns } from "./fillterList.vue?vue&type=template&id=fa36fca6&scoped=true&"
import script from "./fillterList.vue?vue&type=script&lang=js&"
export * from "./fillterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa36fca6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VChipGroup,VEditDialog})
